<script setup lang="ts">
defineProps<{
  context: {
    label: string
    disabled: boolean
    attrs: Record<string, any>
    node: { props: Record<string, any> }
  }
}>()
</script>

<template>
  <UButton
    type="button"
    :label="context.label"
    :color="context.node.props.color"
    :variant="context.node.props.variant"
    :size="context.node.props.size"
    :icon="context.node.props.icon"
    :leading-icon="context.node.props.leadingIcon"
    :trailing-icon="context.node.props.trailingIcon"
    :loading="context.node.props.loading"
    :block="context.node.props.block"
    :disabled="context.disabled"
    @click="context.attrs.onClick"
  />
</template>
